import { render, staticRenderFns } from "./list_pengajuan_force.vue?vue&type=template&id=82c023ae"
import script from "./list_pengajuan_force.vue?vue&type=script&lang=js"
export * from "./list_pengajuan_force.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QPagination,QDialog,QCardActions,QIcon,QSeparator,QImg,QList,QItem,QItemSection,QBadge,QToggle,QFile,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QPagination,QDialog,QCardActions,QIcon,QSeparator,QImg,QList,QItem,QItemSection,QBadge,QToggle,QFile})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
